export default __webpack_public_path__ + "static/Cambridge-d43755d7ed6387d141b45f759143da78.png";